import { createContext, type ReactNode, useContext } from 'react';

const CalendarReturnHrefContext = createContext<string | null>(null);

interface CalendarReturnHrefProviderProps {
  /** The calendar route, with view and day, that a lead link should return to. */
  href: string;
  children: ReactNode;
}

// The calendar route knows which view and day the rep is looking at; the
// controls that leave the calendar (OpenLeadLink) sit several components
// deeper and only need the resulting href.
export function CalendarReturnHrefProvider({
  href,
  children,
}: Readonly<CalendarReturnHrefProviderProps>) {
  return (
    <CalendarReturnHrefContext.Provider value={href}>{children}</CalendarReturnHrefContext.Provider>
  );
}

export function useCalendarReturnHref(): string | null {
  return useContext(CalendarReturnHrefContext);
}
